import React, { Component } from 'react';
import './narrative-board-dropdown.css';
import { connect } from 'react-redux';
import history from '../../../helper/history';
import { Message, Dropdown, Icon, Segment,Dimmer,Loader } from 'semantic-ui-react';
import * as microsoftTeams from "@microsoft/teams-js";
import { setNarrativeBoardMessage, getTeams, addCardToNarrativeBoard } from '../../../actions/narrative-board.actions';
import { NARRATIVEBOARDCONFIG } from '../narrative-board-config';
import { NarrativeBoardOption, AddCardNarrativeBoardInfo } from '../../../modal/narrative-board';
import { CONFIG } from '../../../helper/config';
import { storeSessionId } from '../../../actions/view.actions';
import { ChartConfigInfo } from '../../../modal/filters';
import _ from 'lodash';

interface IProps {
    narrative_board_options: NarrativeBoardOption[];
    narrative_board_msg: string;
    is_license_expire: boolean;
    sessionId:string;
    sequence_id?: any;
    notify_me_from_inside?: boolean;
    teams_default_view:ChartConfigInfo;
    template_config?:any;
    setNarrativeBoardMessage: (arg: string) => void;
    getTeams: (arg0: any, arg1: string, auth_token: string) => void;
    addCardToNarrativeBoard: (arg0: any, arg1: string, auth_token: string) => void;
    storeSessionId:(arg: string) => void;
}

interface IState {
    selected_team: string;
    teams_context: any;
    port_no: string;
    token_string:string;
}

/**
 * NarrativeBoardDropDown Component
 *
 * Provides a dropdown for selecting a team inside the Narrative Board feature.
 * Works in both **Microsoft Teams** and **WebApp** contexts:
 *
 * - In **Teams**, initializes the Teams SDK, retrieves context, and fetches an auth token.
 * - In **WebApp**, listens for `postMessage` events from the parent and extracts session/auth info.
 *
 * Supports:
 * - Selecting a team
 * - Adding a card to the narrative board
 * - Displaying messages and error states
 * - Showing a loader while authenticating
 */
export class NarrativeBoardDropDown extends Component<IProps, IState>{
    auth_token: string = '';
    constructor(props: IProps) {
        super(props);
        this.state = {
            selected_team: '',
            teams_context: {},
            port_no: '',
            token_string:'',
        }
    }


    /**
     * componentDidMount()
     *
     * Called when the component has been mounted.
     *
     * Handles the logic for both Teams and WebApp.
     *
     * For Teams:
     * - Initializes the Microsoft Teams app.
     * - Gets the context (channel, team, user, etc.).
     * - Gets the auth token.
     * - Calls the getHomeVas action with the context and token.
     * - Sets the component state.
     *
     * For WebApp:
     * - Listens for the message event.
     * - Parses the query parameters.
     * - Calls the getHomeVas action with the context and token.
     * - Sets the component state.
     */
    componentDidMount() {
        const query_params = window.location.search.split('?')[1];
        const isWebApp = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[5]:"";
        const port_no: any = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[0] : '';
        const file_name: any = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[1] : '';
        console.log('port No', port_no);
        console.log('File Name', file_name);
    
        if(isWebApp!==CONFIG.WEBAPP){
        if (!this.props.notify_me_from_inside) {
            microsoftTeams.app.initialize();
            microsoftTeams.app.notifySuccess();
        }

        let comp_ref = this;
        const query_params = history.location.search.split('?')[1];
        const port_no: any = (query_params) ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[0] : '';
        console.log("port_no :: ", port_no);
        let teams_context: any = {};
        microsoftTeams.app.getContext().then((context) => {
            console.log("context", context);
            teams_context.userObjectId = context.user?.id;
            teams_context.userPrincipalName = context.user?.userPrincipalName;
            teams_context.tid = context.user?.tenant?.id;
            console.log("teams_context :: ", teams_context);
            comp_ref.setState({ teams_context: teams_context, port_no: port_no });
            microsoftTeams.authentication.getAuthToken().then( (token: string) => {
                    if(!this.props.sessionId){
                        let session_id = new Date().toString();
                          this.props.storeSessionId(session_id)
                        }
                    if (teams_context.userObjectId) {
                        let info = {
                            user_id: teams_context.userObjectId,
                            tenant_id: teams_context.tid
                        }
                        this.auth_token = token;
                        comp_ref.props.getTeams(info, port_no, token);
                    }
                    console.log("token :: ", token);
                    this.setState({token_string:token})
                }).catch((error) => {
                    console.error("error :: ", error);
            })

        });
    }else{
        let webAppData;

        const handleMessage = (event) => {
            if (event.origin !== event?.data?.parentUrl) return;

            webAppData = { ...event.data };
            const token = webAppData.teams_token
            const info = {
              "va_id": query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[2] : '',
              "port_no": port_no,
              "user_id": webAppData.aad_object_id,
              "user_name": webAppData.email,
              "tenant_id": webAppData.tenantId,
              "file_name": file_name,
              "channelId": "msteams"
            }
            this.setState({
              token_string: token,
              teams_context:info
            })
            let session_id = new Date().toString();
            this.props.storeSessionId(session_id)
            this.props.getTeams(info, port_no, token);
        };
        window.addEventListener('message', handleMessage);
    }
    }

    componentWillUnmount() {
        if (this.props.narrative_board_msg.trim() !== '')
            this.props.setNarrativeBoardMessage('')
    }

    /**
     * handleDropdownChange
     *
     * Handles the change event for the dropdown.
     * Retrieves the selected team and updates the state.
     * Calls the addCardToNarrativeBoard action with the selected team information.
     *
     * @param {any} event - The event object.
     * @param {any} data - The data object containing the selected team information.
     */
    handleDropdownChange = (event: any, data: any) => {
        event.preventDefault();
        let { teams_context, port_no } = this.state;
        let { narrative_board_options, sequence_id, notify_me_from_inside, template_config, teams_default_view } = this.props;
        const { name, value } = data;
        this.setState({ [name]: value } as Pick<IState, keyof IState>);
        let destination = narrative_board_options.find(nb => nb.team_id === value);
        let query_params = history.location.search.split('?')[1];
        let info: AddCardNarrativeBoardInfo = {
            user_id: teams_context.userObjectId,
            user_name: teams_context.userPrincipalName,
            user_email: teams_context.userPrincipalName,
            template: (query_params) ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[1] : '',
            destination_id: (destination) ? destination.team_id : '',
            destination_name: (destination) ? destination.team_name : '',
            filters: {},
            tenant_id: teams_context.tid,
            app_id: (destination) ? destination.app_id : '',
            app_name: (destination) ? destination.app_name : '',
            sequence_id: sequence_id,
            va_id: query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[2] : ''
        }

        if(notify_me_from_inside && template_config && !_.isEqual(template_config.default_template_view, teams_default_view)){
            let chart_config = JSON.parse(JSON.stringify(template_config.chart_config));
            let index = chart_config.findIndex(cc => cc.chart_id === teams_default_view.chart_id);
            if(index !== -1){
                chart_config[index] = JSON.parse(JSON.stringify(teams_default_view));
            }
            info.template_config_keys_to_update = {chart_config: chart_config, default_template_view:teams_default_view};
        }
        console.log("info.va_id :: ", info.va_id);
        this.props.addCardToNarrativeBoard(info, port_no, this.auth_token);
    }

    /**
     * getOptions
     *
     * Retrieves the options for the dropdown.
     * Maps the narrative_board_options to create an array of options.
     *
     * @returns {any} - An array of options for the dropdown.
     */
    getOptions = () => {
        let { narrative_board_options } = this.props;
        let options: any = narrative_board_options.map((nbo) => {
            return ({ key: nbo.team_id, text: nbo.team_name, value: nbo.team_id, icon: 'group' })
        });
        options.push({
            key: '0', text: NARRATIVEBOARDCONFIG.INPUT.CHOOSETEAM, value: '',
            className: 'hidden-option', icon: 'group'
        });
        return options;
    }

    /**
     * renderMessage
     *
     * Renders the message based on the narrative_board_msg prop.
     * Displays an error message if the narrative_board_msg is not empty and not equal to the success message.
     *
     * @returns {JSX.Element|null} - A JSX element containing the message or null if no message is available.
     */
    renderMessage = () => {
        let { narrative_board_msg } = this.props;
        if (narrative_board_msg.trim() !== '' && narrative_board_msg !== CONFIG.API.SUCCESSMESSAGE) {
            return <div id='narrative-board-message-container'>
                <Message error content={narrative_board_msg} onDismiss={() => this.props.setNarrativeBoardMessage('')} />
            </div>
        } else {
            return null;
        }
    }

    /**
     * renderPaginationLoader
     *
     * Renders a loader if the active parameter is true.
     * Displays a loading message while the data is being fetched.
     *
     * @param {boolean} active - Indicates whether the loader should be displayed.
     * @returns {JSX.Element|null} - A JSX element containing the loader or null if not active.
     */
    renderPaginationLoader = (active) => {
        let show_loader  = active;
        return show_loader ?
            <Dimmer  active={true} >
                <Loader inline='centered' size='large'>{CONFIG.LOADER_TEXT}</Loader>
            </Dimmer> : null
    }

    /**
     * Renders the NarrativeBoardDropDown component.
     * Handles three states:
     * - License expired → shows warning message
     * - No token yet → shows loader
     * - Otherwise → shows dropdown and message (if any)
     *
     * @returns The rendered JSX
     */
    render() {
        let { narrative_board_msg, is_license_expire} = this.props;
        let { selected_team,token_string } = this.state;
        let narrative_board_options = this.getOptions();

        if (is_license_expire) {
            return <Segment placeholder textAlign="center" size="large" content={CONFIG.LICENSE_EXPIRE} />
        }else if(!token_string){
            return (<div data-testid="select-team-dropdown">{this.renderPaginationLoader(true)}</div>)
        }
        else {
            return (<>
                {(narrative_board_msg === CONFIG.API.SUCCESSMESSAGE) ?
                    <Segment textAlign='center' className='success-message-div'>
                        <Icon name='check circle' color='green' size='massive' />
                        {/* <Header as='h4' content={narrative_board_msg} /> */}
                    </Segment> : <>
                        <Dropdown fluid placeholder={NARRATIVEBOARDCONFIG.INPUT.CHOOSETEAM}
                            label={NARRATIVEBOARDCONFIG.INPUT.CHOOSETEAM}
                            options={narrative_board_options}
                            selection
                            data-testid="select-team-dropdown"
                            // icon='angle down' 
                            name='selected_team'
                            // trigger={  <span>
                            //     <Icon name='group' />{selected_team}
                            //   </span>}
                            value={selected_team} id='select-team-dropdown'
                            // error={submitted && database_type.trim() === ''}
                            onChange={this.handleDropdownChange} upward={false} />
                        {this.renderMessage()}
                    </>
                }
            </>)
        }
    }
}


/**
 * Maps state to props for the NarrativeBoardDropdown component.
 * Retrieves the narrative_board_options, narrative_board_msg, theme, is_license_expire, teams_default_view, and sessionId from the state.
 * @param {Object} state - The state of the application.
 * @returns {Object} A props object containing the narrative_board_options, narrative_board_msg, theme, is_license_expire, teams_default_view, and sessionId.
 */
const mapStateToProps = (state: any) => {
    let { narrative_board_options, narrative_board_msg } = state.narrativeBoardState;
    let {sessionId} = state.viewState;
    return ({
        narrative_board_msg: narrative_board_msg,
        narrative_board_options: JSON.parse(JSON.stringify(narrative_board_options)),
        theme: state.viewState.theme,
        is_license_expire: state.viewState.is_license_expire,
        teams_default_view: state.cardLibraryState.teams_default_view,
        sessionId
    });
};

export default connect(mapStateToProps, { setNarrativeBoardMessage, getTeams, addCardToNarrativeBoard,storeSessionId })(NarrativeBoardDropDown);